export default "__VITE_ASSET__CQvaYHCc__"